// Per-agency cap on AvailabilityRequest.minCapacity ("party size" on the
// request form). Keyed by the Agency.scanner enum. Shared by the client form
// (RequestForm) and the server-side validator (AvailabilityRequestForm) —
// keep this module free of server-only or client-only imports.
export const DEFAULT_MAX_PARTY_SIZE = 8;

export const MAX_PARTY_SIZE_BY_AGENCY = {
  // NZ DOC huts are booked per-bunk and tramping groups run large; large
  // huts have 21+ bunks available on a single night.
  NZDOC: 21,
  // The Thorsborne Trail pass sells to groups of at most six hikers; the
  // provider refuses a seventh even on a start date with room.
  ThorsborneTrail: 6,
};

export function getMaxPartySize(scanner) {
  return MAX_PARTY_SIZE_BY_AGENCY[scanner] ?? DEFAULT_MAX_PARTY_SIZE;
}
